/**
 * @module @shared/config/sdk
 * Baut den `GlobalLoginConfig`-Vertrag des SDK aus der aufgelösten Env.
 * Wird vom Supabase-Client (`@shared/api/supabase`) und vom
 * `GlobalLoginProvider` (`@app/providers`) geteilt.
 */
import type { GlobalLoginConfig } from '@repo/global-login-sdk';
import { env } from './env';

/** SDK-Konfiguration der Login-App, abgeleitet aus den `VITE_*`-Variablen. */
export const globalLoginConfig: GlobalLoginConfig = {
  supabaseUrl: env.supabaseUrl,
  publishableKey: env.publishableKey,
  appSlug: env.appSlug,
  loginUrl: env.loginUrl,
  cookieDomain: env.cookieDomain,
};
